/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ListPolicyPlanComponentsParams = zod.object({
	version: zod.uuid().optional()
});

export type ListPolicyPlanComponentsParams = zod.input<typeof ListPolicyPlanComponentsParams>;
export type ListPolicyPlanComponentsParamsOutput = zod.output<
	typeof ListPolicyPlanComponentsParams
>;
